import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import Footer from '../Common/components/Footer';

import {
  AgreementView,
  ConfirmationView,
  MarketingSection,
  RegisterHeader,
  RegistrationForm
} from './components';

import {
  pageSx,
  heroSx,
  heroInnerSx,
  registerHeroContentSx as heroContentSx,
  registerHeroTitleSx as heroTitleSx,
  registerHeroDescriptionSx as heroDescriptionSx
} from '../Common/components/Styles/AuthStyles';

const VIEW = {
  REGISTER: 'register',
  AGREEMENT: 'agreement',
  CONFIRMATION: 'confirmation'
};

const initialFormValues = {
  firstName: '',
  lastName: '',
  title: '',
  phone: '',
  email: '',

  organizationName: '',
  organizationWebsite: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  medicalLicense: '',
  npi: '',
  dea: '',

  username: '',
  password: '',
  confirmPassword: ''
};

const RegisterPractice = ({ history }) => {
  const [step, setStep] = useState(1);

  const [view, setView] = useState(VIEW.REGISTER);

  const [formValues, setFormValues] = useState(initialFormValues);

  const handleChange = event => {
    const { name, value } = event.target;

    setFormValues(current => ({
      ...current,
      [name]: value
    }));
  };

  const handleNext = () => {
    if (step < 3) {
      setStep(current => current + 1);

      return;
    }

    setView(VIEW.AGREEMENT);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handlePrevious = () => {
    setStep(current => Math.max(current - 1, 1));
  };

  const handleAgreementCancel = () => {
    setView(VIEW.REGISTER);

    setStep(3);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleAgree = () => {
    setView(VIEW.CONFIRMATION);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleSignIn = () => {
    history.push('/sign-in');
  };

  return (
    <Box
      sx={{
        ...pageSx,
        overflow: 'visible'
      }}>
      <RegisterHeader showSignIn={view === VIEW.REGISTER} />

      {view === VIEW.REGISTER && (
        <>
          <Box sx={heroSx}>
            <Box sx={heroInnerSx}>
              <Box sx={heroContentSx}>
                <Typography component="h1" sx={heroTitleSx}>
                  Spend less time documenting.
                  <br />
                  More time caring for patients.
                </Typography>

                <Typography sx={heroDescriptionSx}>
                  EHRZip is a secure, cloud-based electronic health record
                  designed for independent practices. Simplify clinical
                  documentation, manage appointments, streamline patient
                  communication, and access your practice from anywhere.
                </Typography>
              </Box>

              <RegistrationForm
                step={step}
                formValues={formValues}
                onChange={handleChange}
                onNext={handleNext}
                onPrevious={handlePrevious}
              />
            </Box>
          </Box>

          <MarketingSection />
        </>
      )}

      {view === VIEW.AGREEMENT && (
        <AgreementView onCancel={handleAgreementCancel} onAgree={handleAgree} />
      )}

      {view === VIEW.CONFIRMATION && (
        <ConfirmationView
          firstName={formValues.firstName}
          onSignIn={handleSignIn}
        />
      )}

      <Footer />
    </Box>
  );
};

RegisterPractice.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(RegisterPractice);
